<template>
  <div style="width: 100vw;">
    <div class="center-block-date">
      <DatePicker v-model="queryModel.startDate" type="month" size="small" :clearable="false" style="width: 100px"
        :options="dateOptions" @on-change="handleChangeDate"></DatePicker>
      <span class="m-l-5 m-r-5">至</span>
      <DatePicker v-model="queryModel.endDate"  type="month" size="small" :clearable="false" style="width: 100px"
        :options="dateOptions" @on-change="handleChangeDate"></DatePicker>
    </div>

    <div class="kpi-center-block" style="left:6px;right:2px">
      <CenterLeft :style="{'background': waterImageUrl}" style="border-right: 2px solid #1a1a1a;" class="kpi-center-block-content"/>
      <CenterRight :style="{'background': waterImageUrl}" class="kpi-center-block-content"/>
    </div>
  </div>
</template>

<script>
import CenterLeft from '../centerComponents/Center_Left'
import CenterRight from '../centerComponents/Center_Right'

import { getStorage } from '@/utils/storage'
import { getUserWaterImage } from '@/api/dw/image'
import { lastMonthDate, ParseDate } from '@/utils/dateFormat'
import { getCompanyDateConfig } from '@/api/dw/time'

export default {
  components: {
    CenterLeft, CenterRight
  },
  data () {
    return {
      publisherId: this.$store.getters.token.userInfo.publisherId,
      loginCompanyId: this.$store.getters.token.userInfo.companyId,
      dateOptions: {}, // 禁用时间项
      waterImageUrl: '',

      queryModel: {
        endDate: '',
        startDate: ''
      }
    }
  },
  created () {
    this.queryModel.startDate = this.searchSchedule.startDate
    this.queryModel.endDate = this.searchSchedule.endDate
    this.initPageData()
    this.loadWaterImage()
  },
  methods: {
    initPageData () {
      const postData = { companyId: this.loginCompanyId }
      getCompanyDateConfig(postData).then(res => {
        this.dateOptions = {
          disabledDate (date) {
            return (date && date.valueOf() < new Date(res.startDate).valueOf() - 86400000) ||
            (date && date.valueOf() > new Date(res.endDate).valueOf())
          }
        }
      })
    },
    handleChangeDate () {
      const curEndDate = new Date(this.queryModel.endDate)
      const formatEndDate = lastMonthDate(curEndDate.getFullYear(), curEndDate.getMonth() + 1)

      const schedule = {
        startDate: ParseDate(this.queryModel.startDate),
        endDate: ParseDate(formatEndDate)
      }

      this.$store.commit('set_situation_companyId', (this.loginCompanyId === this.publisherId) ? '0' : this.loginCompanyId)

      this.$store.commit('set_situation_searchSchedule', schedule)
    },
    loadWaterImage () { // 载入水印图片
      const param = {
        loginUserId: this.$store.getters.token.userInfo.userId,
        color: this.themeIsDark ? 'black' : 'white'
      }

      getUserWaterImage(param).then(res => {
        this.waterImageUrl = 'url(' + res[0].value + ') repeat'
      })
    }
  },
  computed: {
    searchSchedule () {
      return this.$store.state.situationWeb.searchSchedule
    },
    themeIsDark () {
      // 获取并设置当前页面的主题
      const theme = getStorage('oohforce-workbench-theme') || 'dark'
      return theme === 'dark'
    }
  }
}
</script>

<style scoped>
.kpi-center-block{
  bottom: 2px;
  position: absolute;
  top: 75px;
}
.kpi-center-block-content{
  width: 50%;
  display: inline-block;
  height: 100%;
}
</style>
